import React, {useCallback, useState} from 'react';
import { useDispatch} from 'react-redux';
import { Loader, Divider } from 'rsuite';
import * as actionsUser  from '../../../../app/actions/user';
import {BackIcon} from '../svg/iconsSvg';
import  LoginComponent from './components/LoginComponent';

const LoginProfile = ({onForward, onBack, style}) => {

    const dispatch = useDispatch();

    const [loading, setLoading] = useState(false);
    const [loadingDetails, setLoadingDetails] = useState(false);

    const goBack = () => onBack()

    const goForward = useCallback((toStep) => {
        toStep = toStep || 3;

        const loadUserDetails = async () => {
            setLoading(true);
            setLoadingDetails(true);
            await dispatch(actionsUser.getUser());
            await dispatch(actionsUser.getUserAddresses());
            onForward(toStep);
        }

        if(toStep === 3) {
            if(!loadingDetails) loadUserDetails();

        } else {
            onForward(toStep);
        }
    }, [onForward,loadingDetails, dispatch]);

    return (
        <div className="steps_container" style={{...style, paddingBottom: '18px'}}>
            <div className="head">
                <div className="head-icon" onClick={goBack}><BackIcon size={32}/></div>
                <h6 className="title" style={{marginRight: '48px'}}>Влез в профил</h6>
            </div>
            <Divider />
            <LoginComponent onClose={goForward} submitText="Влез в профил"> 
                <h6 className="title" style={{textAlign: 'center', fontSize:'.875rem', cursor: 'pointer'}} onClick={()=>goForward(2)}>Забравена парола</h6>
               
            </LoginComponent>

            {loading ? <Loader backdrop center size="lg" speed="slow" /> : null }
        </div>
    )
}

export default  LoginProfile;
